module.exports = __webpack_public_path__ + "img/specialeffects-1_en.08135fb.jpg";